import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["current"];
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Order as SessionOrder } from '../../src/components/Checkout/Session/Order';
import SubscriptionOrder from '../../src/components/Checkout/SubscriptionPlan/Order';
import Authorized from '../../src/containers/Authorized';
import paymentService from '../../src/services/payments';
import { createBooking as createBookingAction, createSubscription as createSubscriptionAction, getOrder, getProviderServiceById as getProviderServiceAction, getServiceCustomersByUserIdAndServiceId as getServiceCustomersByUserIdAndServiceIdAction, getSession as getSessionAction, getSessionAccess as getSessionAccessAction, getSubscriptionPlanById as getSubscriptionPlanByIdAction, getUserPaymentSources as getUserPaymentSourcesAction, initOrderPayment as initOrderPaymentAction, updateOrder as updateOrderAction } from '../../src/state/actions';
import { getQuery } from '../../src/utils/helpers';
import { poll } from '../../src/utils/request';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CheckoutPage = function CheckoutPage(_ref) {
  var userId = _ref.userId,
      cardOnFile = _ref.cardOnFile,
      plans = _ref.plans,
      sessions = _ref.sessions,
      sessionAccess = _ref.sessionAccess,
      services = _ref.services,
      orders = _ref.orders,
      completedOrderIds = _ref.completedOrderIds,
      getOrderData = _ref.getOrderData,
      initOrderPayment = _ref.initOrderPayment,
      createSubscription = _ref.createSubscription,
      createBooking = _ref.createBooking,
      getUserPaymentSources = _ref.getUserPaymentSources,
      getServiceCustomersByUserIdAndServiceId = _ref.getServiceCustomersByUserIdAndServiceId,
      updateOrder = _ref.updateOrder;
  var router = useRouter();
  var query = router.query;
  var orderId = getQuery(query.orderId); // Since we don't want to show "checkout completed" in the middle of doing the checkout, we only update this state value once based on the reducer's state, *before* the change is made in order_payment_success

  var _useState = useState(false),
      orderComplete = _useState[0],
      setOrderComplete = _useState[1];

  var redirectURL = getQuery(query.redirectURL) || getQuery(query.redirect);
  var currentOrder = orders[orderId];
  var currentPlan = currentOrder ? plans[currentOrder.planId] : null;
  var currentSession = currentOrder ? sessions[currentOrder.sessionId] : null;
  var currentService = currentOrder ? services[currentOrder.providerService.id] : null;

  if (currentOrder) {
    currentOrder.providerService = currentService ? currentService : currentOrder.providerService;
  }

  var currentSessionAccess = currentSession ? sessionAccess[currentSession.id] : null;
  useEffect(function () {
    if (!orderId) return;
    getOrderData(orderId).then(function (order) {
      var isOrderComplete = completedOrderIds.includes(orderId);

      if (order.status && order.status.startsWith('requires')) {
        isOrderComplete = false;
      }

      setOrderComplete(isOrderComplete);
    });
  }, [orderId]);
  useEffect(function () {
    if (!userId) return;
    getUserPaymentSources(userId);
  }, [userId]);

  var verifyPayment = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var requestFn, waitCondition;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              requestFn = function requestFn() {
                return paymentService.getOrder(orderId);
              };

              waitCondition = function waitCondition(order) {
                return order.status !== 'succeeded';
              };

              return _context.abrupt("return", poll(requestFn, waitCondition, 1500));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function verifyPayment() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsx("div", {
    className: "h-full",
    children: /*#__PURE__*/_jsx(Authorized, {
      children: orderComplete ? /*#__PURE__*/_jsx("div", {
        className: "font-serif text-3xl flex items-center justify-center h-full",
        children: "This order has already been completed."
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [currentPlan ? /*#__PURE__*/_jsx(SubscriptionOrder, {
          plan: currentPlan,
          order: currentOrder,
          initOrderPayment: initOrderPayment,
          createBooking: createBooking,
          createSubscription: createSubscription,
          verifyPayment: verifyPayment,
          cardOnFile: cardOnFile,
          redirectURL: redirectURL,
          getServiceCustomersByUserIdAndServiceId: getServiceCustomersByUserIdAndServiceId,
          getOrder: getOrderData,
          updateOrder: updateOrder,
          userId: userId
        }) : null, currentSession ? /*#__PURE__*/_jsx(SessionOrder, {
          session: currentSession,
          sessionAccess: currentSessionAccess,
          order: currentOrder,
          initOrderPayment: initOrderPayment,
          createBooking: createBooking,
          verifyPayment: verifyPayment,
          cardOnFile: cardOnFile,
          getServiceCustomersByUserIdAndServiceId: getServiceCustomersByUserIdAndServiceId
        }) : null]
      })
    })
  });
};

var mapStateToProps = function mapStateToProps(state) {
  var currentUser = state.auth.users.current; // eslint-disable-next-line

  var _state$payment$paymen = state.payment.paymentSources,
      current = _state$payment$paymen.current,
      otherCards = _objectWithoutProperties(_state$payment$paymen, _excluded);

  var cardOnFile = Object.values(otherCards)[0];
  return {
    userId: currentUser ? currentUser.id : null,
    cardOnFile: cardOnFile,
    orders: state.payment.orders,
    plans: state.subscriptions.plans,
    paymentsLoading: state.payment.loading,
    sessions: state.session.sessions,
    services: state.provider.providerServices,
    sessionAccess: state.session.sessionAccess,
    completedOrderIds: state.payment.completedOrderIds
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getOrderData: function getOrderData(orderId) {
      return dispatch(getOrder(orderId)).then(function (order) {
        if (order) {
          var planId = order.planId,
              sessionId = order.sessionId;
          dispatch(getProviderServiceAction(order.providerService.id));

          if (planId) {
            dispatch(getSubscriptionPlanByIdAction(planId));
          } else if (sessionId) {
            dispatch(getSessionAction(sessionId));
            dispatch(getSessionAccessAction(sessionId));
          }
        }

        return order;
      });
    },
    initOrderPayment: function initOrderPayment(initOrder, stripeCardToken) {
      return dispatch(initOrderPaymentAction(initOrder, stripeCardToken));
    },
    createSubscription: function createSubscription(payload) {
      return dispatch(createSubscriptionAction(payload));
    },
    createBooking: function createBooking(dto) {
      return dispatch(createBookingAction(dto));
    },
    getUserPaymentSources: function getUserPaymentSources(userId) {
      return dispatch(getUserPaymentSourcesAction(userId));
    },
    getServiceCustomersByUserIdAndServiceId: function getServiceCustomersByUserIdAndServiceId(userId, serviceId) {
      return dispatch(getServiceCustomersByUserIdAndServiceIdAction(userId, serviceId));
    },
    updateOrder: function updateOrder(orderId, dto) {
      return dispatch(updateOrderAction(orderId, dto));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutPage);